/* eslint-disable */ 
import {useState } from "react";
import { Flex, Text, Icon, useColorModeValue, useToast } from '@chakra-ui/react'; 
import { TbFileInvoice } from 'react-icons/tb';

// Custom components   

import CommonDatatable from 'components/datatable/CommonDatatable';
import Actions from 'views/privado/servicesPostsales/reporteOperativo/components/Actions';

import service from 'services/reporteOperativoService';

import { 
  createColumnHelper
} from '@tanstack/react-table'
  
type RowObj = {
    radsC3: string;
    raY55HOJOB: number;
    raY55IMJOB: number;
    raN8_RADSC2: string;
    raY55NUHOU: string;
    radsC1: string;
    raA427: string;
    rabndldsc: string;
    raB76FCPD: string;
    raB76NCDC: string;
    raY55DEIT: string;
    raaaju: string;
    raY55TOBIM: number;
    raaaG1: number;
    raaaG2: number;
    raaaG3: number;
    raaaG4: number;
    raY55TOITE: number;
    raY55TOPEB: number;
    raY55TIEM: string;
    raY55ATA: Date;
    raY55HATA: string;
    radesC5: string;
    raY55ATD: Date;
    raY55HATD: string;
    raY55ETA: Date;
    raY55HETA: string;
    raY55ETD: Date;
    raY55HETD: string;
    raabF1: number;
    raabF2: number;
    raabF3: number;
    raabF4: number;
    raaA30: string;
    raY55TOBIMString: string;
    raaaG1String: string;
    raaaG2String: string;
    raaaG3String: string;
    raaaG4String: string;
    raY55ATAString: string;
    raY55ATDString: string;
    raY55ETAString: string;
    raY55ETDString: string; 
};
type RowObj2 = {
    radsC3: string;
    raY55HOJOB: number;
    raY55IMJOB: number;
    raN8_RADSC2: string;
    rADSC2: string;
    rAAN8: number;
    raY55NUHOU: string;
    radsC1: string;
    raA427: string;
    rAY55FEANU: string;
    rAY56HACRE: string;
    rAY55FECPRO: string;
    rAY56HAPER: string;
    rabndldsc: string;
    raB76FCPD: string;
    raB76NCDC: string;
    raY55DEIT: string;
    raaaju: string;
    raY55TOBIM: number;
    raaaG1: number;
    raaaG2: number;
    raaaG3: number;
    raaaG4: number;
    raY55TOITE: number;
    raY55TOPEB: number;
    raY55TIEM: string;
    raY55ATA: string;
    raY55HATA: string;
    radesC5: string;
    raY55ATD: string;
    raY55HATD: string;
    raY55ETA: string;
    raY55HETA: string;
    raY55ETD: string;
    raY55HETD: string;
    raabF1: number;
    raabF2: number;
    raabF3: number;
    raabF4: number;
    rAABF5: number;
    rAADNL: number;
    raaA30: string;
    raY55TOBIMString: string;
    raY55ATAString: string;
    raY55ATAStringHora: string;
    raY55ATDString: string;
    raY55ETAString: string;
    raY55ETDString: string;
    rAY55FEANUString: string;
    rAY55FECPROString: string;
};

import { EXPORT_TITLE, EXPORT_DESCRIPTION } from "const/CommonConst";

export default function DataTable() {
	const textColor = useColorModeValue("navy.700", "white");

  const toast = useToast()

  const [esOperacion1, setEsOperacion1] = useState(true);

  const [tableData, setTableData] = useState([]);
  const [tableDataOperacion2, setTableDataOperacion2] = useState([]);

  const [showEmptyState, setShowEmptyState] = useState(true);
  const [disabledActions, setDisabledActions] = useState(false);
  const [showProgressSearch, setShowProgressSearch] = useState(false);
  const [showProgressExport, setShowProgressExport] = useState(false);
  

  const fetchData = async (code:string, fechaInicio:string, fechaFin:string, esOpe1:boolean) => {
    return esOpe1 ? await service.getTablaOperacion1(code, fechaInicio, fechaFin) : await service.getTablaOperacion2(code, fechaInicio, fechaFin);
  };
  const fetchDataExport = async (code:string, fechaInicio:string, fechaFin:string, esOpe1:boolean) => {
    return esOpe1 ? await service.getExcelOperacion1(code, fechaInicio, fechaFin) : await service.getExcelOperacion2(code, fechaInicio, fechaFin);
  };

  const onChangeFilters = async (selected:any) => {
	try {
		setShowEmptyState(false);
	setDisabledActions(true);
	setShowProgressSearch(true);

	const esOpe1 = selected.operacion === '1'
	setEsOperacion1(esOpe1)

	if (esOpe1){
		setTableDataOperacion2([])
		setTableData(await fetchData(selected.cliente, selected.fechaInicio, selected.fechaFin, esOpe1));
	}
	else{
		setTableData([])
		setTableDataOperacion2(await fetchData(selected.cliente, selected.fechaInicio, selected.fechaFin, esOpe1));
	}
}
  finally{
	setDisabledActions(false);
	setShowProgressSearch(false);
  }
  };

  const onExportData = async (selected:any) => {
	try {
	setDisabledActions(true);
	setShowProgressExport(true);
	const esOpe1 = selected.operacion === '1'
	await fetchDataExport(selected.cliente, selected.fechaInicio, selected.fechaFin, esOpe1);
	toast({
		title: EXPORT_TITLE,
		description: EXPORT_DESCRIPTION,
		status: 'success',
		duration: 9000,
		isClosable: true,
	  });
}
  finally{
	setDisabledActions(false);
	setShowProgressExport(false);
  }
  };

    const columnHelper = createColumnHelper<RowObj>();
    const columnHelperOperacion2 = createColumnHelper<RowObj2>();
 	const columns = [
		columnHelper.accessor('radsC3', {
			id: 'radsC3',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					SUCURSAL
				</Text>
			),
			cell: (info: any) => (
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}), 
		columnHelper.accessor('raN8_RADSC2', {
			id: 'raN8_RADSC2',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					CLIENTE
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('raY55HOJOB', {
			id: 'raY55HOJOB',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					EXP. CONSOLIDADO
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
          {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('raY55IMJOB', {
			id: 'raY55IMJOB',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					EXP. ADUANA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			  </Text>
			)
		}),
		columnHelper.accessor('raY55NUHOU', {
			id: 'raY55NUHOU',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					DOC. TRANSPORTE
				</Text>
			),
			cell: (info) => (
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}),
		columnHelper.accessor('radsC1', {
			id: 'radsC1',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        ORIGEN
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('raA427', {
			id: 'raA427',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        PROVEEDOR
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('rabndldsc', {
			id: 'rabndldsc',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        ORDEN DE COMPRA/ REFERENCIA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('raB76FCPD', {
			id: 'raB76FCPD',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        FACTURAS
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('raB76NCDC', {
			id: 'raB76NCDC',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        NUMERO DE CONTENEDOR
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelper.accessor('raY55DEIT', {
			id: 'raY55DEIT',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        NUMERO DE CONTROL SIDUNEA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelper.accessor('raaaju', {
			id: 'raaaju',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        CANAL DE SELECTIVIDAD
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelper.accessor('raY55TOBIMString', {
			id: 'raY55TOBIMString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        BASE IMPONIBLE BS
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelper.accessor('raaaG1String', {
			id: 'raaaG1String',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        IMPUESTO DE IMPORTACION
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelper.accessor('raaaG2String', {
			id: 'raaaG2String',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        TASA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelper.accessor('raaaG3String', {
			id: 'raaaG3String',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        IVA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelper.accessor('raaaG4String', {
			id: 'raaaG4String',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        OTROS IMPUESTOS
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelper.accessor('raY55TOITE', {
			id: 'raY55TOITE',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        BULTOS
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelper.accessor('raY55TOPEB', {
			id: 'raY55TOPEB',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        PESO BRUTO
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelper.accessor('raY55TIEM', {
			id: 'raY55TIEM',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        TIPO EMBARQUE
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelper.accessor('raY55ATAString', {
			id: 'raY55ATAString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        FECHA DE LLEGADA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('raY55HATA', {
			id: 'raY55HATA',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        HORA DE LLEGADA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('radesC5', {
			id: 'radesC5',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        BUQUE / VUELO / PLACA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('raY55ATDString', {
			id: 'raY55ATDString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        DOC. COMPLETA NACIONALIZAR
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('raY55HATD', {
			id: 'raY55HATD',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        HORA COMPLETA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('raY55ETAString', {
			id: 'raY55ETAString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        DESPACHO
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('raY55HETA', {
			id: 'raY55HETA',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                       HORA DESPACHO
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('raY55ETDString', {
			id: 'raY55ETDString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        MERCANCIA ENTREGADA AL CLIENTE
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('raY55HETD', {
			id: 'raY55HETD',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                       HORA M. ENTREGADA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('raabF1', {
			id: 'raabF1',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        LLEGADA-DESPACHADO DIAS HABILES
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('raabF2', {
			id: 'raabF2',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        LLEGADA-DESPACHADO HORA HABILES
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('raabF3', {
			id: 'raabF3',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        DOC: COMPLETA-DESPACHO DIAS HABILES
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelper.accessor('raabF4', {
			id: 'raabF4',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        DOC: COMPLETA-DESPACHO HORAS HABILES
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		})
	];

	const columnsOperacion2 = [
		columnHelperOperacion2.accessor('radsC3', {
			id: 'radsC3',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					SUCURSAL
				</Text>
			),
			cell: (info: any) => (
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}), 
		columnHelperOperacion2.accessor('raN8_RADSC2', {
			id: 'raN8_RADSC2',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					CLIENTE
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}),
		columnHelperOperacion2.accessor('raY55HOJOB', {
			id: 'raY55HOJOB',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					EXP. CONSOLIDADO
				</Text>
			),
			cell: (info) => ( 
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
          {info.getValue()}
        </Text>
			)
		}),
		columnHelperOperacion2.accessor('raY55IMJOB', {
			id: 'raY55IMJOB',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					EXP. ADUANA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			  </Text>
			)
		}),
		columnHelperOperacion2.accessor('raY55NUHOU', {
			id: 'raY55NUHOU',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					DOC. TRANSPORTE
				</Text>
			),
			cell: (info) => (
        <Text color={textColor} align='left' fontSize='md' fontWeight='500'>
            {info.getValue()}
        </Text>
			)
		}),
		columnHelperOperacion2.accessor('radsC1', {
			id: 'radsC1',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        DESTINO
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelperOperacion2.accessor('raA427', {
			id: 'raA427',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        CONSIGNATARIO
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelperOperacion2.accessor('rabndldsc', {
			id: 'rabndldsc',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        ORDEN DE COMPRA / REFERENCIA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelperOperacion2.accessor('raB76FCPD', {
			id: 'raB76FCPD',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        FACTURAS
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelperOperacion2.accessor('raB76NCDC', {
			id: 'raB76NCDC',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        NUMERO DE CONTENEDOR
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelperOperacion2.accessor('raY55TOBIMString', {
			id: 'raY55TOBIMString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        VALOR FOB BS
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelperOperacion2.accessor('raY55TOITE', {
			id: 'raY55TOITE',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        BULTOS
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelperOperacion2.accessor('raY55TOPEB', {
			id: 'raY55TOPEB',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        PESO BRUTO
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelperOperacion2.accessor('raY55TIEM', {
			id: 'raY55TIEM',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        TIPO EMBARQUE
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelperOperacion2.accessor('raY55ATAString', {
			id: 'raY55ATAString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        FECHA DE LLEGADA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelperOperacion2.accessor('raY55ATAStringHora', {
			id: 'raY55ATAStringHora',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        HORA DE LLEGADA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelperOperacion2.accessor('radesC5', {
			id: 'radesC5',
			header: () => (
				<Text
					justifyContent='space-between'
					align='right'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        BUQUE / VUELO / PLACA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='right' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelperOperacion2.accessor('raY55ATDString', {
			id: 'raY55ATDString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        FECHA DOC. RECIBIDA DEL CLIENTE
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelperOperacion2.accessor('raY55HATD', {
			id: 'raY55HATD',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        HORA DOC. RECIBIDA DEL CLIENTE
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelperOperacion2.accessor('raY55ETAString', {
			id: 'raY55ETAString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        FECHA INTRODUCIDO EN ADUANA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelperOperacion2.accessor('raY55HETA', {
			id: 'raY55HETA',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        HORA INTRODUCIDO EN ADUANA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}) ,
		columnHelperOperacion2.accessor('raY55ETDString', {
			id: 'raY55ETDString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        FECHA CHEQUEO ANTIDROGAS / RESGUARDO
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelperOperacion2.accessor('raY55HETD', {
			id: 'raY55HETD',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        HORA CHEQUEO ANTIDROGAS / RESGUARDO
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelperOperacion2.accessor('rAY55FEANUString', {
			id: 'rAY55FEANUString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        FECHA EMBARQUE LISTO Y ENTREGADO A LA LINEA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelperOperacion2.accessor('rAY56HACRE', {
			id: 'rAY56HACRE',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        HORA EMBARQUE LISTO Y ENTREGADO A LA LINEA
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelperOperacion2.accessor('rAY55FECPROString', {
			id: 'rAY55FECPROString',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        FECHA EMBARCADO Y NOTIFICADO AL CLIENTE
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelperOperacion2.accessor('rAY56HAPER', {
			id: 'rAY56HAPER',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        HORA EMBARCADO Y NOTIFICADO AL CLIENTE
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelperOperacion2.accessor('raabF1', {
			id: 'raabF1',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                       DOC. RECIBIDA DEL CLIENTE - EMBARCADO Y NOTIFICADO AL CLIENTE DIAS HABILES
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelperOperacion2.accessor('raabF2', {
			id: 'raabF2',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					DOC. RECIBIDA DEL CLIENTE - EMBARCADO Y NOTIFICADO AL CLIENTE HORAS HABILES
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelperOperacion2.accessor('raabF3', {
			id: 'raabF3',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                       INTRODUCIDO EN ADUANA - EMBARCADO Y NOTIFICADO AL CLIENTE DIAS HABILES
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelperOperacion2.accessor('raabF4', {
			id: 'raabF4',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					INTRODUCIDO EN ADUANA - EMBARCADO Y NOTIFICADO AL CLIENTE HORAS HABILES
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelperOperacion2.accessor('rAABF5', {
			id: 'rAABF5',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
                        CHEQUEO ANTIDROGA / RESGUARDO - EMBARCADO Y NOTIFICADO AL CLIENTE DIAS HABILES
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		}),
		columnHelperOperacion2.accessor('rAADNL', {
			id: 'rAADNL',
			header: () => (
				<Text
					justifyContent='space-between'
					align='left'
					fontSize={{ sm: '10px', lg: '12px' }}
					color='gray.400'>
					CHEQUEO ANTIDROGA / RESGUARDO - EMBARCADO Y NOTIFICADO AL CLIENTE HORAS HABILES
				</Text>
			),
			cell: (info) => ( 
				<Text color={textColor} align='left' fontSize='md' fontWeight='500'>
				{info.getValue()}
			</Text>
			)
		})
	];
	
  return ( 
	
    <CommonDatatable
    columnsDefinition={esOperacion1 ? columns : columnsOperacion2}
    tableData={esOperacion1 ? tableData : tableDataOperacion2}
	showEmptyState={showEmptyState}
	isLoading={disabledActions}
    actionContent={    
        <Actions onChange={onChangeFilters} 
				 onExport={onExportData} 
				 disabledActions={disabledActions} 
				 showProgressExport={showProgressExport} 
				 showProgressSearch={showProgressSearch} /> }
      />        
  )
} 
